module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_vm._v("\n      站内信\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "contentBox"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "newBox"
  }, [_c('ul', {
    staticClass: "common-list-box"
  }, _vm._l((_vm.msgList), function(item, index) {
    return _c('li', [_c('a', {
      staticClass: "paddingLink",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.listDown(index, item.id)
        }
      }
    }, [_c('p', {
      staticClass: "item-top"
    }, [_c('span', {
      staticClass: "itemLeft",
      class: {
        'msg-read': item.msg_read === '0'
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "itemRight"
    }, [_vm._v(_vm._s(item.pub_time))])]), _vm._v(" "), _c('p', {
      staticClass: "item-content",
      class: {
        'active': index === _vm.msgIndex
      }
    }, [_vm._v("\n                " + _vm._s(item.content) + "\n\t\t\t\t\t\t\t")])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "clearfix pager-wrapper"
  }, [_c('div', {
    staticClass: "pagination",
    attrs: {
      "id": "pager"
    }
  }, [_c('span', {
    staticClass: "page-button pager-prev",
    class: {
      disabled: _vm.pager.page == 1
    },
    on: {
      "click": function($event) {
        _vm.pageNum(_vm.pager.page, 'up')
      }
    }
  }, [_vm._v("上一页")]), _vm._v(" "), _c('span', {
    staticClass: "page-info"
  }), _vm._v(" " + _vm._s(_vm.pager.page) + "/" + _vm._s(_vm.pager.count) + "\n            "), _c('span', {
    staticClass: "page-button pager-next",
    class: {
      disabled: _vm.pager.page == _vm.pager.count || _vm.pager.count == 0
    },
    on: {
      "click": function($event) {
        _vm.pageNum(_vm.pager.page, "down")
      }
    }
  }, [_vm._v("下一页")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-current-title"
  }, [_c('div', {
    staticClass: "text-overflow"
  }, [_c('span', [_vm._v("全部消息")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-763ba26b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/message.vue
// module id = nmXT
// module chunks = 1